import { NUMERIRIVISTE, PAGINEDETAIL, RIVISTE, SLUG } from 'utils/endpoint'
import React, { useState } from 'react'
import { useTrans } from 'hooks'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import Error from 'next/error'
import MetaSeo from 'components/atomic/MetaSeo'
import { api } from 'utils'
import { ListingRivistaByAnno } from 'react-components/organisms'
import groupBy from 'lodash/groupBy'

const RivistaArchivio = React.memo(({ rivista, initialListing, page, statusCode }) => {
  if (!rivista) return <Error statusCode={statusCode} />

  const [groupListing, setListingGroup] = useState(groupBy(initialListing.results, 'anno_solare'))

  const t = useTrans()

  return (
    <>
      {groupListing ? (
        <>
          <MetaSeo seo={page.seo} />

          <main className="rivista-page">
            <div className="w-container">
              <Breadcrumbs breadcrumbs={page.breadcrumbs} />
            </div>

            <div className="w-container">
              <section className="rivista-page__header ">
                <div className="w-container">
                  <h1 className="rivista-page__header__title">{rivista.titolo}</h1>
                  <h2 className="rivista-page__header__description">{t('Archivio')}</h2>
                </div>
              </section>
            </div>

            <div className="w-container">
              <section className="rivista-page__listing ">
                {Object.keys(groupListing)
                  .sort()
                  .reverse()
                  .map((key, index) => (
                    <ListingRivistaByAnno anno={key} lista_riviste={groupListing[key]} />
                  ))}
              </section>
            </div>
          </main>
        </>
      ) : null}
    </>
  )
})

export async function getStaticPaths() {
  const response = await api.get(RIVISTE)
  const riviste = response.data

  const paths = riviste.map(r => ({
    params: { slug: r.slug },
  }))

  return {
    paths,
    fallback: 'blocking',
  }
}

export const getStaticProps = async ({ params: { slug } }) => {
  try {
    const response = await api.get(`${RIVISTE}${SLUG}${slug}/`)
    const rivista = response.data

    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'riviste-detail-archivio',
        content_type_id: rivista.model,
        object_id: rivista.id,
      },
    })
    const page = await pageResponse.data

    const params = {
      page_size: 99999999999999999999,
      page: 1,
      rivista_id: rivista.id,
    }
    const listingResponse = await api.get(NUMERIRIVISTE, { params })
    const initialListing = listingResponse.data

    const toolbarProps = { toolbarItem: rivista, toolbarPage: page }

    return {
      props: { rivista, initialListing, page, key: rivista.id, ...toolbarProps },
      revalidate: 60,
    }
  } catch (error) {
    console.log(error)
    return {
      notFound: true,
    }
  }
}

export default RivistaArchivio
